import React, { FC, ReactNode } from "react";

export type DashboardWidgetHeaderProps = {
  icon: ReactNode;
  title: string;
  value?: number | string;
  badgeNode?: ReactNode;
  endNode?: ReactNode;
};

export const DashboardWidgetHeader: FC<DashboardWidgetHeaderProps> = ({
  icon,
  title,
  value,
  badgeNode,
  endNode,
}) => {
  return (
    <div className="relative flex h-5 w-full shrink-0 flex-row items-center justify-between">
      <div className="flex min-w-0 items-center gap-2">
        <span className="shrink-0 text-light-stone [&_svg]:size-5">{icon}</span>
        <span className="truncate text-sm font-semibold leading-tight tracking-normal text-neutral-900">
          {title}
        </span>
        {value !== undefined ? (
          <span className="shrink-0 text-sm font-medium leading-tight text-neutral-900">
            {value}
          </span>
        ) : null}
      </div>
      {badgeNode ? (
        <div className="pointer-events-auto absolute -right-7 -top-1 z-10 shrink-0">
          {badgeNode}
        </div>
      ) : null}
      {endNode ? (
        <div className="pointer-events-auto shrink-0">{endNode}</div>
      ) : null}
    </div>
  );
};
